export default __webpack_public_path__ + "static/media/icon.plaster.77770266.svg";